import { render } from "./UserCommonManagerView.vue?vue&type=template&id=e826e7c4"
import script from "./UserCommonManagerView.vue?vue&type=script&lang=js"
export * from "./UserCommonManagerView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__